// Lib
import { ListingUI } from 'features/Dealers/Listings/state/types';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { ChatmeterAccount, ChatmeterLocation } from './types';

export interface ActionGetChatmeterLocationsAPI extends Action {
    query?: string
    limit?: number
    offset?: number
}

export const getChatmeterLocationsAPI = (query:string, limit?:number, offset?:number): ActionGetChatmeterLocationsAPI => ({
    type: ACTIONS.GET_CHATMETERLOCATIONS_API_REQUEST,
    query,
    limit,
    offset
});

export const getChatmeterDeactiveLocationsAPI = (query:string, limit?:number, offset?:number): ActionGetChatmeterLocationsAPI => ({
    type: ACTIONS.GET_CHATMETERDEACTIVELOCATIONS_API_REQUEST,
    query,
    limit,
    offset
});

export interface ActionGetChatmeterLocationsAPISuccess extends Action {
    locations: ChatmeterLocation[]
}



export const getChatmeterLocationsAPISuccess = (locations: ChatmeterLocation[]): ActionGetChatmeterLocationsAPISuccess => ({
    type: ACTIONS.GET_CHATMETERLOCATIONS_API_SUCCESS,
    locations
});

export const getChatmeterDeactiveLocationsAPISuccess = (locations: ChatmeterLocation[]): ActionGetChatmeterLocationsAPISuccess => ({
    type: ACTIONS.GET_CHATMETERDEACTIVELOCATIONS_API_SUCCESS,
    locations
});


export const getChatmeterLocationsAPIError = (error: any): Action => ({
    type: ACTIONS.GET_CHATMETERLOCATIONS_API_ERROR,
});

export const getChatmeterDeactiveLocationsAPIError = (error: any): Action => ({
    type: ACTIONS.GET_CHATMETERDEACTIVELOCATIONS_API_ERROR
});



export interface ActionGetChatmeterAccountsAPI extends Action {
    query?: string
}

export const getChatmeterAccountsAPI = (query:string): ActionGetChatmeterAccountsAPI => ({
    type: ACTIONS.GET_CHATMETERACCOUNTS_API_REQUEST,
    query
});

export interface ActionGetChatmeterAccountsAPISuccess extends Action {
    accounts: ChatmeterAccount[]
}

export const getChatmeterAccountsAPISuccess = (accounts: ChatmeterAccount[]): ActionGetChatmeterAccountsAPISuccess => ({
    type: ACTIONS.GET_CHATMETERACCOUNTS_API_SUCCESS,
    accounts
});

export const getChatmeterAccountsAPIError = (error: any): Action => ({
    type: ACTIONS.GET_CHATMETERACCOUNTS_API_ERROR
});


//CHATMETER ACCOUNT

export interface ActionAccountAPI extends Action {    
    id: string
    accountName:string    
}


export const addAccountAPI = (id: string,accountName): ActionAccountAPI => ({
    type: ACTIONS.ADD_CHATMETERACCOUNT_API_REQUEST,
    id,
    accountName

});

export interface ActionAccountAPISuccess extends Action {
    account: ChatmeterAccount
}

export const addAccountAPISuccess = (account: ChatmeterAccount): ActionAccountAPISuccess => ({
    type: ACTIONS.ADD_CHATMETERACCOUNT_API_SUCCESS,
    account
});


export const addAccountAPIError = (error: any): Action => ({
    type: ACTIONS.ADD_CHATMETERACCOUNT_API_ERROR,
});